module.exports = __webpack_public_path__ + "assets/img/market.5e8f0d90.png";